module.exports = __webpack_public_path__ + "img/wavesOpacity.b9e0c0c1.svg";